import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-section-full-screen-video',
  templateUrl: './section-full-screen-video.component.html',
  styleUrls: ['./section-full-screen-video.component.css']
})
export class SectionFullScreenVideoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
